import {AppError} from "./AppError";

export class NotFoundError extends AppError {


  constructor(error) {
    super(error);

  }

}



// WEBPACK FOOTER //
// ./src/app/errors/not-found-error.ts